import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentSuccess() {
  const [sp] = useSearchParams();
  const sid = sp.get("session_id");
  const [tx, setTx] = useState(null);
  const [attempts, setAttempts] = useState(0);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!sid) { setError("Session inconnue."); return; }
    let cancelled = false;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (cancelled) return;
        setTx(data);
        if (data.payment_status === "paid") return; // done
        if (attempts >= 10) { setError("Le paiement met plus de temps que prévu. Vous recevrez un email de confirmation."); return; }
        setAttempts((n) => n + 1);
        setTimeout(poll, 2000);
      } catch (e) {
        setError(e?.response?.data?.detail || "Impossible de vérifier le paiement.");
      }
    };
    poll();
    return () => { cancelled = true; };
    // eslint-disable-next-line
  }, [sid]);

  const paid = tx?.payment_status === "paid";
  const planLabel = tx?.plan_key === "premium" ? "PROXI PREMIUM"
    : tx?.plan_key === "visibilite" ? "PROXI VISIBILITÉ"
    : tx?.plan_key === "essentiel" ? "PROXI ESSENTIEL" : "";
  const isTrial = tx?.plan_key === "visibilite";

  return (
    <div className="max-w-2xl mx-auto px-4 py-16 text-center" data-testid="payment-success-page">
      {paid ? (
        <>
          <div className="w-20 h-20 mx-auto rounded-full bg-emerald-100 text-emerald-700 grid place-items-center">
            <CheckCircle2 size={40}/>
          </div>
          <h1 className="mt-6 font-heading text-3xl md:text-4xl font-extrabold text-slate-900">Merci !</h1>
          <p className="mt-3 text-slate-700">
            Votre abonnement <b>{planLabel}</b> est activé{isTrial
              ? " — vos 30 premiers jours sont offerts, sans engagement."
              : ", sans engagement. Merci de votre confiance !"}
          </p>
          <div className="mt-6 flex flex-wrap gap-3 justify-center">
            <Link to="/pro"><Button className="btn-shine text-white h-11 px-6" data-testid="payment-goto-pro">Accéder à mon espace</Button></Link>
            <Link to="/pro/abonnement"><Button variant="outline" className="h-11 px-6">Gérer mon abonnement</Button></Link>
          </div>
        </>
      ) : error ? (
        <>
          <div className="w-20 h-20 mx-auto rounded-full bg-amber-100 text-amber-700 grid place-items-center"><XCircle size={40}/></div>
          <h1 className="mt-6 font-heading text-2xl font-extrabold">Vérification en cours…</h1>
          <p className="mt-3 text-slate-600">{error}</p>
          <Link to="/pro/abonnement"><Button variant="outline" className="mt-6">Retour à l'abonnement</Button></Link>
        </>
      ) : (
        <>
          <Loader2 size={48} className="animate-spin mx-auto text-[#E05638]"/>
          <h1 className="mt-6 font-heading text-2xl font-extrabold">Confirmation du paiement…</h1>
          <p className="mt-2 text-slate-500 text-sm">Nous vérifions votre paiement auprès de Stripe.</p>
        </>
      )}
    </div>
  );
}
